import { render, staticRenderFns } from "./_forgottenPasswordModal.vue?vue&type=template&id=0515f9d5"
import script from "./_forgottenPasswordModal.vue?vue&type=script&lang=js"
export * from "./_forgottenPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports